<template>
  <base-button
    class="button-ver-mas text-center m-4 sm:m-8 hover:bg-amarillo font-heading transition ease delay-150 "
    :mode="[borde, color]"
    :to="to"
  >
    {{ texto }}
  </base-button>
</template>

<script>
export default {
   props : {
    texto: {
      type: String,
      required: false,
      default: "Leer más",
    },
    color: {
      type: String,
      required: false,
      default: "text-azul",
    },
    borde: {
      type: String,
      required: false,
      default: "border-amarillo",
    },
    to: {
      type: [Object, Array, String],
      required: false,
      default: () => {},
    },
   } 
}
</script>

<style scoped>
  a, button {
    box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.2);
  }

.button-ver-mas {
    font-size: 2rem;
    font-weight: 300;
    padding: 0.3rem 2rem;
}


  .text-bold {
    font-weight: 600;
  }
  

button.button-ver-mas {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

@media screen and (max-width: 240px) {
  .button-ver-mas {
    font-size: 8vw;
    font-weight: 300;
    padding: 0.3rem 1rem;
    margin-left: 0 !important;
    margin-right: 0  !important;
  }
}

@media screen and (min-width: 1300px) {
  .button-ver-mas {
    font-size: 2.5rem;
    font-weight: 500;
    padding: 0.60rem 3.0rem;
  }
}
</style>